export enum CategoryTypeEnum {
  Checkbox = 100000000,
  Radio = 100000001,
  DefaultText = 100000002,
  TextArea = 100000003,
}
